import React, { Fragment, useMemo, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTable, usePagination, useSortBy } from "react-table";
import { COLUMNS, COLUMN_CBSA, COLUMN_C88, COLUMN_CARM } from "./EdiColumns";
import { fetchEdiRespRecords } from "../../store/action/ediRespRecords";
import { fetchEdiReqRecords } from "../../store/action/ediReqRecords";
import { selectedEdiRecords } from "../../store/action/selectedRecords";
import EdiDeletion from "./EdiDeletion";
import { setFlagforPopup } from "../../store/action/ediReqRecords";
import "./table.css";
import _ from "lodash";
import { clearFileSuccessPopup } from "../../store/action/fileEdiRequest";
import { clearRecordCreatedPopup } from "../../store/action/createRecord";
import { clearRecordDeletedPopup } from "../../store/action/deleteRecords";
import EdiCreation from "./EdiCreate";
import { fetchEdidata } from "../../store/action/ediResponse";
import Tooltip from "@material-ui/core/Tooltip";
import { setUsFormTypes } from "../../store/action/formTypeAction";

function EdiRequest(props) {
  const dispatch = useDispatch();
  const EventTypeResponse = {
    GB: "ediTxnRequest",
    US: "ediTxnRequest",
    CA: "cbsaTxnRequest",
    CA_CARM: "carmTransactionResponses"
  };
  const [selectedRow, setselectedRow] = useState();
  // const [usFormType, setUsFormType] = useState("ES");
  const usFormType =
    useSelector((state) => state.formTypeReducer?.usFormType) || "ES";
  const EdiEventType = useSelector((state) => state.edi.edidata?.eventType);
  const EdiEventTime = useSelector((state) => state.edi.edidata?.eventTime);
  const selectedRows = useSelector((state) => state.rowSelected?.selectedRow);
  const requestFiled = useSelector(
    (state) => state.ediRecordFiled?.recordFiled?.eventMessage
  );
  const recordDeleted = useSelector(
    (state) => state.ediRecordDeleted?.recordDeleted
  );
  const Filetime = useSelector(
    (state) => state.rowSelected?.selectedRow?.requestTime
  );
  const Filereason = useSelector(
    (state) => state.rowSelected?.selectedRow?.fileReason
  );
  const requestID = useSelector(
    (state) => state.rowSelected?.selectedRow.requestid
  );
  const country = props.isXMLEnabled ? "CA_CARM" : window.shipmentCountry || props.countryOfBusiness;

  const loader = useSelector((state) => state.edi.loading);
  const shipmentID = useSelector(
    (state) => state.edi.edidata?.eventMessage?.shipmentid || window.shipmentId
  );
  const createdRequest = useSelector(
    (state) => state.ediRecordCreated.recordCreated?.eventMessage
  );
  const dataa = useSelector((state) => state);

  const Edidata = useSelector(
    (state) => state.edi.edidata?.eventMessage?.[EventTypeResponse[country]]
  );
  // console.log("state", window.shipmentCountry);

  // setInterval(() => {
  //   console.log("Edidata", Edidata);
  // }, 2000);

  const getAction = (data) => {
    let dataCopy = _.cloneDeep(data);
    for (let i = 0; i < dataCopy.length; i++) {
      if (country === "CA") {
        if (!dataCopy[i].hasOwnProperty("action")) {
          dataCopy[i]["action"] = "ADD_CBSA";
        }
      }
      if (country !== "CA") {
        if (!dataCopy[i].hasOwnProperty("action")) {
          dataCopy[i]["action"] = "ADD";
        }
      }
      if (dataCopy[i].action === "DELETE") {
        dataCopy[i]["action"] = "RETRACT";
      }
    }
    return dataCopy;
  };

  const TABLEDATA = Edidata ? getAction(Edidata) : [];

  const data = useMemo(() => TABLEDATA, [EdiEventTime, EdiEventType]);
  const columnHeader =
    EdiEventType === "GET_CBSA_REQUEST_MESSAGE"
      ? COLUMN_CBSA
      : EdiEventType === "GET_CBP_REQUEST_MESSAGE"
      ? COLUMNS
      : EdiEventType === "GET_ALL_TRANSACTION_REQUEST_CARM"
      ? COLUMN_CARM
      : COLUMN_C88;
  const columns = useMemo(() => columnHeader, [shipmentID, EdiEventType]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    canNextPage,
    canPreviousPage,
    previousPage,
    gotoPage,
    setPageSize,
    state,
    pageOptions,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 3 },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setPageSize(5);
    dispatch(setUsFormTypes("ES"));
    return () => {
      setselectedRow(null);
    };
  }, [shipmentID]);
  const clearPopups = () => {
    dispatch(clearFileSuccessPopup());
    dispatch(clearRecordCreatedPopup());
    dispatch(clearRecordDeletedPopup());
    dispatch(setFlagforPopup(false));
  };
  const handleGB = (selectedRow) => {
    if (selectedRow.requestTime) {
      dispatch(
        fetchEdiReqRecords(
          selectedRow.requestid,
          country,
          0,
          selectedRow.cspType,
          shipmentID
        )
      );
    } else {
      dispatch(
        fetchEdiReqRecords(
          selectedRow.requestid,
          country,
          1,
          selectedRow.cspType,
          shipmentID
        )
      );
    }
  };
  const handleUS = (selectedRow) => {
    if (selectedRow.requestTime) {
      dispatch(
        fetchEdiReqRecords(
          selectedRow.requestid,
          country,
          0,
          selectedRow.documentType,
          shipmentID
        )
      );
    } else {
      dispatch(
        fetchEdiReqRecords(
          selectedRow.requestid,
          country,
          1,
          selectedRow.documentType,
          shipmentID
        )
      );
    }
  };
  const handleCA = (selectedRow) => {
    if (selectedRow.requestTime) {
      dispatch(
        fetchEdiReqRecords(
          selectedRow.requestid,
          country,
          0,
          selectedRow.formType,
          shipmentID,
          selectedRow
        )
      );
    } else {
      dispatch(
        fetchEdiReqRecords(
          selectedRow.requestid,
          country,
          1,
          selectedRow.formType,
          shipmentID,
          selectedRow
        )
      );
    }
  };

  const handleCA_CARM = (selectedRow) => {

      dispatch(
        fetchEdiReqRecords(
          selectedRow.id,
          country,
          0,
          selectedRow.formType,
          shipmentID,
          selectedRow
        )
      );
  } 
  const rowClicked = (selectedRow) => {
    if (selectedRow.requestTime) {
      dispatch(selectedEdiRecords(selectedRow));
      setselectedRow(selectedRow);
      switch (country) {
        case "GB":
          handleGB(selectedRow);
          break;
        case "US":
          handleUS(selectedRow);
          break;
        case "CA":
          handleCA(selectedRow);
          break;
        default:
          break;
      }
      clearPopups();
    } else {
      dispatch(selectedEdiRecords(selectedRow));

      setselectedRow(selectedRow);
      switch (country) {
        case "GB":
          handleGB(selectedRow);
          break;
        case "US":
          handleUS(selectedRow);
          break;
        case "CA":
          handleCA(selectedRow);
          break;
        default:
          break;
      }
      clearPopups();
      
    }
    dispatch(fetchEdiRespRecords(selectedRow.requestid || selectedRow.id, country));
  };

  const { pageIndex, pageSize } = state;

  let requestLabel = props.isXMLEnabled ? "XML" : "EDI"
  return (
    <div>
      {!loader && requestFiled && Array.isArray(requestFiled.fieldmessage) ? (
        <div className="alert-file">
          {country === "US" ? (
            <span>
              Success &#10003; {requestFiled.fieldmessage[0].fieldmessage} and{" "}
              {requestFiled.fieldmessage[1].fieldmessage}.
              <button
                onClick={() => dispatch(clearFileSuccessPopup())}
                className="alert-button"
              >
                &#10005;
              </button>
            </span>
          ) : country === "GB" ? (
            !loader && (
              <span>
                Success &#10003; {requestFiled.fieldmessage[0].fieldmessage}.
                <button
                  onClick={() => dispatch(clearFileSuccessPopup())}
                  className="alert-button"
                >
                  &#10005;
                </button>
              </span>
            )
          ) : (
            ""
          )}
        </div>
      ) : !loader && requestFiled && country === "CA" ? (
        <div className="alert-file">
          <span>
            Success &#10003; {requestFiled.msg}.
            <button
              onClick={() => dispatch(clearFileSuccessPopup())}
              className="alert-button"
            >
              &#10005;
            </button>
          </span>
        </div>
      ) : (
        ""
      )}

      {!loader && createdRequest?.requestid ? (
        <div className="alert-file">
          <span>
            Success &#10003; New Request Created With RequestID :{" "}
            <b>{createdRequest.requestid}</b>
            <button
              className="alert-button"
              onClick={() => dispatch(clearRecordCreatedPopup())}
            >
              &#10005;
            </button>
          </span>
          <br />
        </div>
      ) : !loader &&
        (createdRequest?.code == 400 || createdRequest?.message) ? (
        <div className="alert-failure">
          <span>
            Error !! Request cannot be created because{" "}
            {createdRequest.msg || createdRequest.message}.
            <button
              className="failure-button"
              onClick={() => dispatch(clearRecordCreatedPopup())}
            >
              &#10005;
            </button>
          </span>
          <br />
        </div>
      ) : (
        ""
      )}
      {!loader && recordDeleted.status === "SUCCESS" && (
        <div className="alert-file">
          <span>
            Success &#10003; Request Deleted With RequestID :{" "}
            <Fragment>
              <b>{recordDeleted.requestid}</b>
              <button
                onClick={() => dispatch(clearRecordDeletedPopup())}
                className="alert-button"
              >
                &#10005;
              </button>
            </Fragment>
          </span>
          <br />
        </div>
      )}
      <br />
      {!loader ? (
        <Fragment>
          <span style={{ display: "inline" }}>
            <h3 style={{ margin: "4px", float: "left" }}>
              {requestLabel} Requests : {shipmentID}
            </h3>
          </span>
          {country === "US" && (
            <span style={{ float: "right" }}>
              <div className="ui buttons esPscBtn">
                <button
                  className={`ui button ${usFormType === "ES" ? "selected" : ""}`}
                  onClick={() => {
                    dispatch(setUsFormTypes("ES"));
                    dispatch(
                      fetchEdidata(
                        shipmentID.replace("PSC_PARENT", "").replace("-PS"),
                        country,
                        "ES",
                        false//isPscRequest
                      )
                    );
                  }}
                >
                  ES
                </button>
                <button
                  className={`ui button ${usFormType === "PSC" ? "selected" : ""}`}
                  onClick={() => {
                    dispatch(setUsFormTypes("PSC"));
                    dispatch(
                      fetchEdidata(
                        shipmentID.replace("PSC_PARENT", "").replace("-PS"),
                        country,
                        "PSC",
                        true//isPscRequest
                      )
                    );
                  }}
                >
                  PSC
                </button>
              </div>
            </span>
          )}
          {!props.readOnlyMode && requestID && !Filetime ? (
            <EdiDeletion {...props} />
          ) : (
            ""
          )}
          {!props.readOnlyMode && <EdiCreation {...props} />}
        </Fragment>
      ) : (
        ""
      )}
      {data.length > 0 && !loader ? (
        <Fragment>
          <table className="edi-table" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      style={{ textAlign: "left" }}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      {column.render("Header")}
                      <span style={{ textAlign: "left" }}>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, index) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    className={
                      (selectedRows?.requestid || selectedRows?.id) === (row.original.requestid || row.original.id)
                        ? `selected-row`
                        : ``
                    }
                    onClick={() => {
                      rowClicked(row.original);
                    }}
                  >
                    {row.cells.map((cell) => {
                      let cellValue = cell.render("Cell");
                      let titleText = cell.value;

                      if (
                        props.shortForm &&
                        (cell.column.id === "documentType" ||
                          cell.column.id === "messagetext")
                      ) {
                        cellValue =
                          cell.value &&
                          cell.value
                            .replace(/([A-Z])[A-Z]*_/g, "$1_")
                            .replace(/([A-Z])[A-Z]*$/g, "$1");
                        return (
                          <td {...cell.getCellProps()}>
                            <span title={titleText}>{cellValue}</span>
                          </td>
                        );
                      } else {
                        return <td {...cell.getCellProps()}>{cellValue}</td>;
                      }
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div
            style={{ width: "100%", height: "34px", border: "1px grey solid" }}
          >
            <div className="pagination-block">
              <select
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
                className="pagination-buttons"
              >
                <option value={5} disabled={!(data.length > 0)}>
                  5 rows
                </option>
                <option value={10} disabled={!(data.length > 5)}>
                  10 rows
                </option>
                <option value={15} disabled={!(data.length > 10)}>
                  15 rows
                </option>
              </select>
              <button
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
                className="pagination-buttons"
              >
                {"|<"}
              </button>
              <button
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                className="pagination-buttons"
              >
                {"<"}
              </button>
              <span className="pagination-buttons">
                Page{" "}
                <strong>
                  {pageIndex + 1} of {pageOptions.length}
                </strong>
                {""}
              </span>
              <button
                onClick={() => nextPage()}
                disabled={!canNextPage}
                className="pagination-buttons"
              >
                {">"}
              </button>
              <button
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
                className="pagination-buttons"
              >
                {">|"}
              </button>
            </div>
          </div>
        </Fragment>
      ) : !loader ? (
        <div>
          <table className="edi-table" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup, i) => (
                <Fragment>
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <td colSpan={9} style={{ textAlign: "center" }}>
                      No Records Found!
                    </td>
                  </tr>
                </Fragment>
              ))}
            </thead>
          </table>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default React.memo(EdiRequest);
